import { FunctionComponent, useEffect, useState } from "react";
import { useCheckout } from "../../context/CheckoutContext";
import styles from "../../pages/CheckoutData/CheckoutDados.module.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Constants } from "../../utils/constants";

const CartProductCard: FunctionComponent = ({
  text,
  title,
  price,
  onSelect,
  selected,
  index,
  quantity,
  img,
  credit_tax,
  debit_tax,
  cred_anual_tax,
  id,
  description,
}: {
  quantity: number;
  text: string;
  id: string;
  img: string;
  title: string;
  onSelect: Function;
  selected: boolean;
  index: number;
  price: number;
  credit_tax: string;
  debit_tax: string;
  cred_anual_tax: string;
  description: string;
}) => {
  const { cart, addToCart, cleanCart } = useCheckout();
  const [removeMessage, setRemoveMessage] = useState(false);
  const [cartQuantity, setQuantity] = useState(quantity);
  const navigate = useNavigate()
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const couponURL = searchParams.get('cupom');

  useEffect(() => {
    setQuantity(quantity);
  }, [quantity])

  const handleClick = (value: number) => {
    const productsQty = cart.reduce((acc, curr) => {
      return acc + curr.quantity
    }, 0)
    if (productsQty + value === 0 && location.pathname !== '/') {
      setRemoveMessage(true);
    } else if (cartQuantity + value !== -1) {
      addToCart({
        id,
        name: title,
        price,
        info: "prod",
        quantity: cartQuantity + value,
        img,
        description,
      });
    }
  };
  function formatNumber(num: number) {
    let formattedNum = num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Replace commas in the integer part with periods
    let parts = formattedNum.split(".");
    parts[0] = parts[0].replace(/,/g, ".");

    // Join the parts back together
    formattedNum = parts.join(",");

    return formattedNum;
  }

  const appInLocalStorage =
    localStorage.getItem(Constants.LOCALSTORAGE.app);
  const appFormattedLocalStorage =
    appInLocalStorage ? JSON.parse(appInLocalStorage) : null;

  return (
    <div className={styles.cardResumo}>
      {removeMessage ? (
        <div>
          <p>
            Removendo esse produto você retornará para a tela inicial
            para escolher novamente o seu plano e máquina. Deseja prosseguir?
          </p>
          <button
            className={styles.removeBtnNot}
            onClick={() => {
              cleanCart();
              navigate(appFormattedLocalStorage
                ? `/${appFormattedLocalStorage.slug}${
                  couponURL ? `?cupom=${couponURL}` : ''
                }`
                : `/${
                  couponURL ? `?cupom=${couponURL}` : ''
                }`
              );
            }}
          >
            SIM
          </button>
          <button
            className={styles.removeBtn}
            onClick={() => setRemoveMessage(false)}
          >
            NÃO
          </button>
        </div>
      ) : (
        <>
          <div className={styles.produto}>
            <div className={styles.imagensMaquininhas}>
              <img
                className={styles.image3Icon}
                alt=""
                src={img ? img : "/image-31@2x.png"}
              />
            </div>
            <div className={styles.info}>
              <div className={styles.div}>{title}</div>
              <div className={styles.unidade}>{`${cartQuantity} ${
                cartQuantity === 1 ? "unidade" : "unidades"
              }`}</div>
              <div className={styles.div}>{`R$${formatNumber(
                parseFloat(price)
              )}`}</div>
            </div>
          </div>
          <div className={styles.picker}>
            <div className={styles.content}>
              <img
                onClick={() => handleClick(-1)}
                className={styles.icones}
                alt=""
                src="/icones37.svg"
              />
              <div className={styles.div3}>{cartQuantity}</div>
              <img
                onClick={() => handleClick(1)}
                className={styles.icones}
                alt=""
                src="/icones38.svg"
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CartProductCard;
